<template>
    <div id="wrapper" :class="'outer-' + $route.name">
        <div class="deveo-wrapper" :class="$route.name">
            <top-menu></top-menu>
            <transition name="slide-fade">
                <router-view></router-view>
            </transition>
        </div>
        <main-footer :skew="skewFooter"></main-footer>
        <mobile-footer></mobile-footer>
        <mobile-menu v-if="$store.state.mobileMenu"></mobile-menu>
        <vue-progress-bar></vue-progress-bar>
        <cookie-notice></cookie-notice>
    </div>
</template>
<script>
    import topMenu from './top-menu.vue'
    import mainFooter from './footer.vue'
    import mobileFooter from './mobile-footer.vue'
    import mobileMenu from './mobile-menu.vue'
    import cookieNotice from './cookie-notice.vue'
    export default {
        name: 'layout',
        components: {
            topMenu,
            mainFooter,
            mobileFooter,
            mobileMenu,
            cookieNotice
        },
        watch: {
            '$i18n.locale': 'setLanguage'
        },
        created () {
            this.checkLanguage()
        },
        methods: {
            checkLanguage () {
                const chosenLanguage = localStorage.getItem('chosenLanguage')
                if (!chosenLanguage) {
                    return
                }
                this.$i18n.locale = chosenLanguage
            },
            setLanguage () {
                localStorage.setItem('chosenLanguage', this.$i18n.locale)
            }
        },
        computed: {
            skewFooter () {
                const currentRoute = this.$route.name

                switch (currentRoute) {
                    case 'Index':
                        return false
                    case 'Contact':
                        return false
                    default:
                        return true
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// layout.vue?ab410e56